import React from 'react';
// eslint-disable-next-line no-restricted-imports
import loadScript, { URLS } from 'Jsx/Utils/loadScript';
import Loader from 'crehana-ui/Loader';
import PayuForm from './PayuForm';

const Payu = () => {
  const [payUjsWasLoaded, setPayUjsWasLoaded] = React.useState(!!window.payU);
  const [loadingPayUjs, setLoadingPayUjs] = React.useState(false);

  React.useEffect(() => {
    if (!payUjsWasLoaded) {
      setLoadingPayUjs(true);
      loadScript({ src: URLS.payu }).then(res => {
        const { PAYU_PUBLIC_KEY, PAYU_SET_URL_API, PAYU_ACCOUNT_PE } = window;

        if (res) {
          window.payU.setURL(PAYU_SET_URL_API);
          window.payU.setPublicKey(PAYU_PUBLIC_KEY);
          window.payU.setAccountID(PAYU_ACCOUNT_PE);
          window.payU.setListBoxID('mylistID');
          window.payU.setLanguage('es');
          window.payU.getPaymentMethods();
          setLoadingPayUjs(false);
          setPayUjsWasLoaded(true);
        }
      });
    }
  }, []);

  if (loadingPayUjs) {
    return (
      <div className="flex justify-center w-full">
        <Loader size={36} />
      </div>
    );
  }

  return <PayuForm />;
};

export default Payu;
